import React from 'react';
import styled from '@emotion/styled';
import { Flex, Grid, Button, Text } from '@applyboard/crystal-ui';
import { useEventTracker } from '@applyboard/ui-utils';

interface ReloadRequirementsMessageProps {
  reloadRequirements: () => void;
  reloadAggregatedData?: () => void;
}

export const ReloadRequirementsMessage = (props: ReloadRequirementsMessageProps) => {
  const { trackEvent } = useEventTracker();

  return (
    <div walkme-id="applications-requirements">
      <Grid mt={10}>
        <Grid.Item width={{ xs: 12 }}>
          <Flex direction="column" align="center" gap={5}>
            <Paragraph>
              <Text as="p">We are still processing the requirements.</Text>
              <Text as="p">Feel free to give it another try by pressing the button below.</Text>
            </Paragraph>
            <Button
              onClick={async () => {
                props.reloadRequirements();
                props.reloadAggregatedData();
                trackEvent({
                  event:
                    'Single Application - Creation - Retry Loading Applicant Requirements Button Clicked',
                });
              }}
              intent="primary"
            >
              Retry Loading
            </Button>
          </Flex>
        </Grid.Item>
      </Grid>
    </div>
  );
};

const Paragraph = styled.div`
  text-align: center;
`;
